/* eslint-disable no-console */
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.css'
import { registerServiceWorker } from './utils/serviceWorker'

// Register service worker
if (import.meta.env.PROD) {
  window.addEventListener('load', () => {
    registerServiceWorker().then((registration) => {
      if (registration) {
        console.log('[Main] Service Worker registered with scope:', registration.scope)
      }
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
